<template>
    <div ref="sentinelRef" />
    <Transition
        v-if="isMounted"
        :enterFromClass="$style.fade_enter_from"
        :enterActiveClass="$style.fade_enter_active"
        :leaveActiveClass="$style.fade_leave_active"
        :leaveToClass="$style.fade_leave_to"
        appear
    >
        <div
            v-if="isBannerVisible"
            :class="$style.banner"
        >
            <AdContainer type="sticky_desktop">
                <template #default="{ isVisible }">
                    <Button
                        v-if="isVisible && isStickyMode"
                        size="s"
                        color="carbon-400"
                        :class="$style.close_button_override"
                        interfaceTarget="close-sticky-desktop-banner"
                        :label="$tr('desktopStickyBanner.closeButtonLabel')"
                        @click="onClose"
                    />
                </template>
            </AdContainer>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'
import { ref } from 'vue'

import AdContainer from '@/components_new/AdContainer/AdContainer.vue'
import Button from '@/components_new/Buttons/Button.vue'
import { useLoggerStore } from '@/store/logger'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'

const loggerStore = useLoggerStore()
const isMounted = useIsMounted()

const isBannerVisible = ref(true)
const isStickyMode = ref(true)

const sentinelRef = ref<HTMLDivElement>()

function onClose() {
    loggerStore.logEvent({
        event: 'custom_event',
        eventName: 'ad_close',
        adPlacement: 'sticky_desktop',
    })
    isBannerVisible.value = false
}

useIntersectionObserver(sentinelRef, (entries) => {
    isStickyMode.value = !entries[0]?.isIntersecting
})
</script>

<style module>
.banner {
    position: sticky;
    bottom: 0;
    z-index: 1;
}

.close_button_override {
    position: absolute;
    top: -25px;
    right: 0;
    pointer-events: auto;
}

.fade_enter_active,
.fade_leave_active {
    transition: all 0.8s ease;
}

.fade_enter_from,
.fade_leave_to {
    transform: translateY(300px);
}
</style>
